import { LeafletLayerComponent } from './../leaflet-layer/leaflet-layer.component';
import { Component } from '@angular/core';

@Component({
    selector: 'leaflet-path',
    template: '',
    standalone: false
})
export class LeafletPathComponent extends LeafletLayerComponent {
}
